import { Checkbox } from 'antd'
import PropTypes from 'prop-types'
import { useGetNewsTips } from 'domains/NewsTip/hooks'
import { useSubfilterActions } from 'hooks'
import { StyledDetails } from '../PointsHistoryFilter.styles'
import { useTranslations } from 'contexts/Translation'
import { Text } from '@qonsoll/react-design'

const NewsTipFilter = ({ filterData, setFilterData }) => {
  // [ADDITIONAL_HOOKS]
  const [newsTips] = useGetNewsTips()
  const { t } = useTranslations()

  // [COMPUTED_PROPERTIES]
  const summaryStyles = { marginBottom: '8px' }

  const { onToggleDetails, onChange, checkIsEnabled } = useSubfilterActions({
    filterData,
    setFilterData,
    fieldName: 'newsTip',
    operand: '=='
  })

  return (
    <StyledDetails
      open={localStorage.getItem(`newsTip-details-visibility`) === 'opened'}>
      <summary style={summaryStyles} onClick={() => onToggleDetails('newsTip')}>
        {t('News tip')}
      </summary>
      {newsTips?.map((newsTip, index) => (
        <div key={`status-${index}`}>
          <Checkbox
            key={`status-${index}`}
            checked={checkIsEnabled(newsTip)}
            onChange={() => onChange(newsTip)}>
            <Text wordBreak="break-all">
              {newsTip?.title || t('Unnamed filter')}
            </Text>
          </Checkbox>
        </div>
      ))}
    </StyledDetails>
  )
}

NewsTipFilter.propTypes = {
  filterData: PropTypes.object,
  setFilterData: PropTypes.func
}

export default NewsTipFilter
